import React from 'react';
import LSModule from "../../components/base/LSModule";
import WidgetRenderer from "../../components/dashboard/WidgetRenderer";

export default class DashboardModule extends LSModule {
    render() {
        return (
            <div className="p-6 lg:p-10 space-y-8 animate-fadeIn">
                {/* Top Welcome Section */}
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-2">
                    <div>
                        <h1 className="text-4xl font-black text-white tracking-tight mb-2">
                            Dashboard
                        </h1>
                        <p className="text-gray-400 text-lg">
                            Sistem durumuna ve hızlı işlemlere göz atın.
                        </p>
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="px-5 py-2.5 rounded-2xl bg-white/[0.03] border border-white/[0.06] flex items-center gap-3">
                            <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
                            <span className="text-sm font-semibold text-gray-300">Sistem Çevrimiçi</span>
                        </div>
                    </div>
                </div>

                {/* Dynamic Widgets via SDUI Renderer */}
                <WidgetRenderer />
            </div>
        );
    }
}